import React from 'react'
import { CasinoUiProvider } from '../../context/CasinoUiContext'
import LotusCasinoProvidersPage from './LotusCasinoProvidersPage'
import './LotusCasinoProvidersPage.css'

const LotusCasinoProvidersRoute = () => (
  <CasinoUiProvider>
    <LotusCasinoProvidersPage />
  </CasinoUiProvider>
)

export default LotusCasinoProvidersRoute

